<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>区域绑定</h4>
        </div>

        <div class="main-bd mg20">
            <p>
                <el-button @click="dialogFormVisible1 = true;submiting1=false">绑定区域</el-button>
                <el-button type="warning" @click="lockAllAreas"><i class="el-icon-fa-lock"></i> 锁定所有区域</el-button>
                <el-button type="success" @click="unlockAllAreas"><i class="el-icon-fa-key"></i> 解锁所有区域</el-button>
            </p>

            <el-alert
                    title="温馨提示"
                    type="info"
                    description="带 图标 🔒 的区域为锁定区域，被锁定的区域的客户除了当前用户其他用户将无法绑定，点击单个区域标签可对其进行锁定&解锁操作">
            </el-alert>

            <el-table
                    :loading="loading"
                    :data="areas"
                    border
                    style="width: 100%">
                <el-table-column prop="full_name" label="所属省市" width="180"></el-table-column>
                <el-table-column prop="address" label="已绑定业务区域">
                    <template slot-scope="scope" >
                        <a>
                        <el-tag
                                class="areaTag"
                                v-for="area in scope.row.districts"
                                :key="area.district_id"
                                @click="handleLock(area)"
                                closable
                                @close="unbindDistrict(area.district_id)"
                        >
                            <i v-if="area.is_lock" class="el-icon-fa-lock"></i> {{area.district_name}}
                        </el-tag>
                        </a>
                    </template>
                </el-table-column>
            </el-table>

            <el-dialog title="选择绑定区域"
                       center
                       :visible.sync="dialogFormVisible1"
                       width="70%"
                       :append-to-body="dialogAppendToBody"
                       :before-close="beforeCloseDialog"
                       top="10vh">
                <el-form label-width="100px" >
                    <el-form-item label="选择省份：" >
                        <el-radio-group class="areaSelect" v-if="provinces.length > 0" v-model="bindForm.province_id">
                            <el-radio-button v-for="province in provinces" :key="province.id" :label="province.id">
                                {{province.name}}
                            </el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="选择城市：" >
                        <el-radio-group class="areaSelect" v-if="cities.length > 0" v-model="bindForm.city_id" size="small">
                            <el-radio-button v-for="city in cities" :key="city.id" :label="city.id">{{city.name}}</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="选择地区：" >
                        <el-transfer v-if="districts.length > 0"
                                     filterable
                                     :filter-method="filterMethod"
                                     filter-placeholder="请输入地区名称"
                                     v-model="bindForm.districts"
                                     :data="formatDistricts()"
                                     :titles="['未选择地区', '已选择地区']" class="districtSelect"
                        >
                        </el-transfer>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="beforeCloseDialog">取 消</el-button>
                    <el-button :loading="submiting1" type="primary" @click="saveBindArea">保 存</el-button>
                </div>
            </el-dialog>

        </div>
        <div class="main-bd mg20">
        <p>
          <el-button @click="dialogFormVisible2 = true;submiting2=false">绑定公海池</el-button>
        </p>

        <el-alert
            title="温馨提示"
            type="info"
            description="绑定公海池后，业务员只能看到绑定区域的可领取客户">
        </el-alert>

        <el-table
            :loading="loading"
            :data="common_areas"
            border
            style="width: 100%">
          <el-table-column prop="full_name" label="所属省市" width="180"></el-table-column>
          <el-table-column prop="address" label="已绑定业务区域">
            <template slot-scope="scope" >
              <a>
                <el-tag
                    class="areaTag"
                    v-for="area in scope.row.districts"
                    :key="area.district_id"
                    closable
                    @close="unbindCommonDistrict(area.district_id)"
                >
                  <i v-if="area.is_lock" class="el-icon-fa-lock"></i> {{area.district_name}}
                </el-tag>
              </a>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog title="选择绑定区域"
                   center
                   :visible.sync="dialogFormVisible2"
                   width="70%"
                   :append-to-body="dialogAppendToBody"
                   :before-close="beforeCloseDialog"
                   top="10vh">
          <el-form label-width="100px" >
            <el-form-item label="选择省份：" >
              <el-radio-group class="areaSelect" v-if="provinces.length > 0" v-model="CommonbindForm.province_id">
                <el-radio-button v-for="province in provinces" :key="province.id" :label="province.id">
                  {{province.name}}
                </el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="选择城市：" >
              <el-radio-group class="areaSelect" v-if="cities.length > 0" v-model="CommonbindForm.city_id" size="small">
                <el-radio-button v-for="city in cities" :key="city.id" :label="city.id">{{city.name}}</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="选择地区：" >
              <el-transfer v-if="districts.length > 0"
                           filterable
                           :filter-method="filterMethod"
                           filter-placeholder="请输入地区名称"
                           v-model="CommonbindForm.districts"
                           :data="formatDistricts1()"
                           :titles="['未选择地区', '已选择地区']" class="districtSelect"
              >
              </el-transfer>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="beforeCloseDialog">取 消</el-button>
            <el-button :loading="submiting2" type="primary" @click="saveCommonBindArea">保 存</el-button>
          </div>
        </el-dialog>

      </div>
    </div>
</template>

<script>
    import UserService from "~/services/user";
    import DistrictService from "~/services/district";
    import common from "~/services/common";

    export default {
        name: "areas",
        data() {
            return {
                loading: true,
                areas: [],
                common_areas:[],
                user: {},
                provinces: [],
                cities: [],
                districts: [],
                dialogFormVisible1: false,
                dialogFormVisible2: false,
                dialogAppendToBody: true,
                submiting1: false,
                submiting2: false,
                bindForm: {
                    user_id: 0,
                    province_id: 0,
                    city_id: 0,
                    districts: []
                },
                CommonbindForm: {
                  user_id: 0,
                  province_id: 0,
                  city_id: 0,
                  districts: []
                },
                userId: null,
            }
        },
        created: function () {

            this.userId = this.$route.query['id'];
            this.getUser();
            if (parseInt(this.userId) > 0) {
                this.bindForm.user_id = this.userId;
                this.CommonbindForm.user_id = this.userId;
                this.getAreas(this.userId);
                this.getCommonAreas(this.userId);
            }
            this.getProvinces();
        },
        watch: {
            'bindForm.province_id': function (value, oldValue) {
                this.cities = [];
                this.districts = [];
                if (parseInt(value) > 0) {
                    this.getCitesByProvinceId(value);
                    this.bindForm.districts = [];
                }
            },

            'bindForm.city_id': function (value, oldValue) {
                this.districts = [];
                if (parseInt(value) > 0) {
                    this.getDistrictsByCityId(value);
                    this.bindForm.districts = [];
                }
            },
          //公海池
          'CommonbindForm.province_id': function (value, oldValue) {
            this.cities = [];
            this.districts = [];
            if (parseInt(value) > 0) {
              this.getCitesByProvinceId(value);
              this.bindForm.districts = [];
            }
          },

          'CommonbindForm.city_id': function (value, oldValue) {
            this.districts = [];
            if (parseInt(value) > 0) {
              this.getCommonDistrictsByCityId(value,this.userId);
              this.bindForm.districts = [];
            }
          },

        },

        methods: {
            getUser() {

                if (parseInt(this.userId) < 1) {
                    return false;
                }

                UserService.getInfo(this.userId).then(res => {
                    if (res.code == 0) {
                        //this.loading = false;
                        this.user = res.data;
                        return true;
                    } else {
                        console.error(res.msg);
                        return false;
                    }
                })
            },

            getAreas(userId) {
                if (parseInt(userId) < 1) {
                    return false;
                }
                UserService.getAreas(userId).then(res => {
                    if (res.code == 0) {
                        this.areas = res.data;
                        return true;
                    } else {
                        console.error(res.msg);
                        return false;
                    }
                });
            },
          getCommonAreas(userId) {
            if (parseInt(userId) < 1) {
              return false;
            }
            UserService.getCommonAreas(userId).then(res => {
              if (res.code == 0) {
                this.common_areas = res.data;
                return true;
              } else {

                return false;
              }
            });
          },

            /**
             * 得到省份列表
             */
            getProvinces() {
                DistrictService.getProvinces().then(res => {
                    if (res && res.code == 0) {
                        this.provinces = res.data;
                    }
                })
            },

            /**
             * 得到指定省份下的城市
             * @param provinceId
             */
            getCitesByProvinceId(provinceId) {
                DistrictService.getCities(provinceId).then(res => {
                    if (res && res.code == 0) {
                        this.cities = res.data;
                    }
                });
            },

            /**
             * 得到指定城市下的城市
             * @param provinceId
             */
            getDistrictsByCityId(cityId) {
                UserService.getDistricts(cityId).then(res => {
                    if (res && res.code == 0) {
                        this.districts = res.data;
                    }
                })
            },
            /**
             * 公海池得到指定城市下的城市
             */
            getCommonDistrictsByCityId(cityId,userid) {
              UserService.getCommonDistricts(cityId,userid).then(res => {
                if (res && res.code == 0) {
                  this.districts = res.data;
                }
              })
            },

            /**
             * 监听弹出窗口关闭前触发事件
             */
            beforeCloseDialog() {
                this.closeDialog();
                // this.$confirm("陛下你还没有保存内容，确认要关闭窗口？").then(_ => {
                //     this.closeDialog();
                // }).catch(_ => {
                //     return;
                // });
            },

            closeDialog() {
                // 清空表单
                this.bindForm.province_id = 0;
                this.bindForm.city_id = 0;
                this.bindForm.districts = [];
                this.CommonbindForm.province_id = 0;
                this.CommonbindForm.city_id = 0;
                this.CommonbindForm.districts = [];

                this.dialogFormVisible1 = false;
                this.dialogFormVisible2 = false;
            },

            // 搜索过滤地区
            filterMethod(query, item) {
                return item.label.indexOf(query) > -1;
            },

            /**
             * 格式化地区数据
             * @returns {Array}
             */
            formatDistricts() {
                const data = [];
                this.districts.forEach((dist, index) => {
                    data.push({
                        label: dist.name,
                        key: dist.id,
                        disabled: dist.disabled
                    });
                })
                return data;
            },
          formatDistricts1() {
            const data = [];
            this.districts.forEach((dist, index) => {
              data.push({
                label: dist.name,
                key: dist.id,
                disabled: dist.disabled
              });
            })
            return data;
          },

            saveBindArea() {
                this.submiting1 = true;
                UserService.bindArea(this.bindForm).then(res => {
                    this.submiting1 = false;
                    if (res && res.code == 0) {
                        this.$message({
                            message: "绑定成功!",
                            type: "success",
                            showClose: true,
                        });
                        this.closeDialog();
                      this.getAreas(this.userId);
                      this.getCommonAreas(this.userId);
                    }
                }).catch(err => {
                    this.submiting1 = false;
                    console.error(err);
                })
            },
          saveCommonBindArea() {
            this.submiting2 = true;
            UserService.bindCommonArea(this.CommonbindForm).then(res => {
              this.submiting2 = false;
              if (res && res.code == 0) {
                this.$message({
                  message: "绑定成功!",
                  type: "success",
                  showClose: true,
                });
                this.closeDialog();
                this.getCommonAreas(this.user.id);
              }
            }).catch(err => {
              this.submiting2 = false;
              console.error(err);
            })
          },

            unbindDistrict(districtId) {
                this.$confirm("确认要解绑该地区？", "温馨提示", {type: "warning"}).then(_ => {
                    UserService.unbindArea(this.user.id, [districtId]).then(res => {
                        if (res && res.code == 0) {
                            this.$message({
                                message: "解绑成功!",
                                type: "success",
                                showClose: true,
                            });
                          this.getAreas(this.userId);
                          this.getCommonAreas(this.userId);
                        }
                    })
                }).catch(err => {
                    console.error(err);
                    return;
                });
            },
          unbindCommonDistrict(districtId) {
            this.$confirm("确认要解绑该地区？", "温馨提示", {type: "warning"}).then(_ => {
              UserService.unbindCommonArea(this.user.id, [districtId]).then(res => {
                if (res && res.code == 0) {
                  this.$message({
                    message: "解绑成功!",
                    type: "success",
                    showClose: true,
                  });
                  this.getAreas(this.userId);
                  this.getCommonAreas(this.userId);
                }
              })
            }).catch(err => {
              console.error(err);
              return;
            });
          },

            handleLock(item) {
                if (item.is_lock) {
                    this.unlock(item);
                } else {
                    this.lock(item);
                }
            },

            lock(item) {
                this.$confirm("即将锁定该区域，锁定后其他用户将无法关联绑定该区域客户，确认要锁定吗？", "温馨提示", {type: "warning"}).then(_ => {
                    UserService.lockArea(this.user.id, item.id).then(res => {
                        if (res && res.code == 0) {
                            this.$message({
                                message: "锁定成功!",
                                type: "success",
                                showClose: true,
                            });
                            this.getAreas(this.user.id);
                        }
                    })
                }).catch(cancel => {

                });
                return;
            },

            unlock(item) {
                this.$confirm("即将解锁该区域，解锁后其他用户将可以关联绑定该区域客户，确认要解锁吗？", "温馨提示", {type: "warning"}).then(_ => {
                    UserService.unlockArea(this.user.id, item.id).then(res => {
                        if (res && res.code == 0) {
                            this.$message({
                                message: "解锁成功!",
                                type: "success",
                                showClose: true,
                            });
                            this.getAreas(this.user.id);
                        }
                    })
                }).catch(cancel => {
                });
                return;
            },

            lockAllAreas() {
                this.$confirm("确认要锁定所有区域吗？", "温馨提示", {type: "warning"}).then(_ => {
                    UserService.lockArea(this.user.id, 0).then(res => {
                        if (res && res.code == 0) {
                            this.$message({
                                message: "锁定成功!",
                                type: "success",
                                showClose: true,
                            });
                            this.getAreas(this.user.id);
                        }
                    })
                }).catch(err => {
                    console.error(err);
                });
                return;
            },

            unlockAllAreas() {
                this.$confirm("确认要解锁所有区域吗？", "温馨提示", {type: "warning"}).then(_ => {
                    UserService.unlockArea(this.user.id, 0).then(res => {
                        if (res && res.code == 0) {
                            this.$message({
                                message: "解锁成功!",
                                type: "success",
                                showClose: true,
                            });
                            this.getAreas(this.user.id);
                        }
                    })
                }).catch(err => {
                    console.error(err);
                });
                return;
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/user/areas.vue